import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
//import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate, useParams } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";


// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ReservationModifyName: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const { id, idx } = useParams();

	const navigate = useNavigate ();
	//const navigationType = useNavigationType();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	let textSub = "";
	
	// const textUpdateRequired = "등록된 이름이 없어요";
	// const textSetting = "설정됨";
	
	// const _familyName = initData.userInfo.familyName;
	// const _givenName = initData.userInfo.givenName;

	const [familyName, setFamilyName] = useState("");
	const [givenName, setGivenName] = useState("");


	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate(`/reservation/${id}`);
		} else {
			(async () => {

				const res: any = await requestAPI('GET', `v1/reserve/${id}`, null);

				const traveler = res.data.info.traveler[Number(idx)];

				const _familyName = (traveler.familyName===null)
					? ""
					: traveler.familyName;
				const _givenName = (traveler.givenName===null)
					? ""
					: traveler.givenName;

				setFamilyName(_familyName);
				setGivenName(_givenName);
			})();
		}
		
	}, []);
	
	if (familyName === "" && givenName === "") {
		textSub = "설정된 이름이 없어요."
	} else {
		textSub = `현재 등록된 이름은 [${familyName}${givenName}]이에요.`;
		
	}
	const handleSubmit = async () => {
		// const _initData = {...initData};
		// const _id = _initData.userInfo._id;

		// const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/name`, {
		// 	familyName,
		// 	givenName
		// });

		const res_info: any = await requestAPI ('PUT', `v1/reserve/${id}/traveler-name/${idx}`, {
			familyName,
			givenName
		});

		if (res_info.code === 1000) {
			
			navigate(`/reservation/${id}`)	
		}
	};
	
	

	const handleBack = () => {
		navigate(`/reservation/${id}`);
	}

	return (
		<>
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>
				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									이름 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />
						
						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경하실 이름을 입력해주세요
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								{textSub}
							</span>
						</div>

						<div className="mt-10" />

						


						<div className="mt-10 md:ml-10 md:mr-10">
							<div className="flex justify-center items-end w-full">
								<div className="w-[80px]">
									<h2
										className={`text-lg nc-card-title text-neutral-900 dark:text-neutral-100 font-semibold`}
									>
										성
									</h2>
									<span
										className={`text-sm block text-neutral-500 dark:text-neutral-400`}
									>
										<Input
											value={familyName}
											onChange={e => setFamilyName (e.target.value)}
										/>
									</span>
								</div>	
								<div className="w-[150px] ml-2">
									<h2
										className={`text-lg nc-card-title text-neutral-900 dark:text-neutral-100 font-semibold`}
									>
										이름
									</h2>
									<span
										className={`text-sm block text-neutral-500 dark:text-neutral-400`}
									>
										<Input
											value={givenName}
											onChange={e => setGivenName (e.target.value)}
										/>
									</span>
								</div>
							</div>
							

						</div>


						
						<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
							
							<ButtonPrimary
								onClick={() => handleSubmit()}
							>
								수정
							</ButtonPrimary>
						</div>						
						

					</div>

				</div>
				
			</div>
		</>
	);
};

export default ReservationModifyName;
